import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../../../Components/Panel/Panel";
import { Card, CardText, CardBody, CardTitle, Button } from "reactstrap";
import ConfigWrite from "../../../Write";

export default () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleModal = () => {
    setIsVisible(!isVisible);
  };
  return (
    <>
      <Helmet>
        <title>드림상점 관리 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item ">
            <Link to="/giftConfigs">드림상점</Link>
          </li>
          <li className="breadcrumb-item active">상품</li>
        </ol>
        <h1 className="page-header">상품</h1>
        <div className="row">
          <div className="col-xl-12">
            <Panel>
              <PanelHeader noButton={true}>설정</PanelHeader>
              <PanelBody>
                <Card className="border-0 width-full text-center p-t-40 p-b-40">
                  <CardBody>
                    <CardTitle tag="h2" className="m-t-5 m-b-10">
                      <i className="fa fa-cogs fa-fw"></i> 드림상점 설정
                    </CardTitle>
                    <CardText className="m-b-15">
                      드림상점에 대한 설정사항을 등록해야 이용할 수 잆습니다.
                      <br />
                      설정을 등록해주세요.
                    </CardText>
                    <Button
                      onClick={() => {
                        toggleModal();
                      }}
                      className="btn btn-warning btn-sm"
                    >
                      등록
                    </Button>
                  </CardBody>
                </Card>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
      <ConfigWrite isVisible={isVisible} toggleModal={toggleModal} />
    </>
  );
};
